// extracted by mini-css-extract-plugin
export default {"logs":"Lym9X","loader":"AsNP2","terminal":"Vs5Qg","scroll":"ZXmZb"};